export enum Permisos
{

    /*  ASIGNACIÓN      DE    EQUIPOS */
    SOLICITAREQUIPO                 =  "SOLICITAR EQUIPO",
    SOLICITUDESREALIZADAS           =  "VER TODAS LAS SOLICITUDES REALIZADAS",
    DETALLESOLICITUDSOLICITANTE     =  "VER SOLICITUD A DETALLE SOLICITANTE",
    GESTIONSOLICITUDES              =  "GESTIONAR TODAS LAS SOLICITUDES",
    DETALLESOLICITUDADMINISTRADOR   =  "VER SOLICITUD A DETALLE",
    ASIGNAREQUIPODEESCRITORIO       =  "ASIGNAR COMPUTADORA DE ESCRITORIO",
    ASIGNACIONDIRECTA               =  "ASIGNAR EQUIPO SIN SOLICITUD",
    ASIGNACIONSOLICITUD             =  "ASIGNAR EQUIPO CON SOLICITUD",
    REASIGNACIONDEEQUIPO            =  "REASIGNAR EQUIPOS DE EMPLEADO",
    CONTROLASIGNACIONES             =  "CONTROL DE ASIGNACIONES",
    ASIGNACIONESEMPLEADO            =  "CONTROL DE ASIGNACIONES DE EQUIPO DE EMPLEADO",
    DETALLEASIGNACION               =  "VER DETALLE ASIGNACION DE EQUIPO",
    REMPLAZARCOMPONENTEEQUIPO       =  "REMPLAZAR COMPONENTE",


    /* MANTENIMEINTO */
    PROGRAMARMANTENIMIENTO          =   "AGENDAR MANTENIMIENTO",
    REGISTRARMANTENIMIENTO          =   "REGISTRAR MANTENIMIENTO",
    CONTROLMANTENIMEINTO            =   "CONTROL DE MANTENIMIENTOS",
    DETALLEEDITMANTENIMEINTO        =   "EDITAR MANTENIMIENTO",
    DETALLEMANTENIMEINTO            =   "VER DETALLE DE MANTENIMIENTO",

            /**Inventario */
    ALTAEQUIPO               = "ALTA EQUIPO",
    GESTIONEQUIPOS           = "GESTION EQUIPOS",
    DETALLEEQUIPO            = "DETALLE EQUIPO",
    GESTIONTIPOSEQUIPOS      = "GESTION TIPOS EQUIPOS",
    GESTIONMODELOSEQUIPOS    = "GESTION MODELOS EQUIPOS",

           /**Atencion de Usuarios */
    SOLICITARSERVICIOS       = "SOLICITAR SERVICIOS",
    VISUALIZARSOLICITUDES    = "VISUALIZAR SOLICITUDES",
    DETALLESOLICITUD         = "DETALLE SOLICITUD",

    ATENDERSOLICITUDES       = "ATENDER SOLICITUDES",
    APROBARSOLICITUDALTA     = "APROBAR SOLICITUD ALTA",
    APROBARSOLICITUDACT      = "APROBAR SOLICITUD ACT",
    APROBARSOLICITUDSUSP     = "APROBAR SOLICITUD SUSP",
    ADMINISTRARUSUARIOS      = "ADMINISTRAR USUARIOS",
    EXPEDIENTES              = "EXPEDIENTES",
    SEGUIMIENTO              = "SEGUIMIENTO",
    GESTIONTIPOSSOLICITUD    = "GESTION TIPOS SOLICITUD",
    GESTIONTIPOSSERVICIOS    = "GESTION TIPOS SERVICIOS",
    GESTIONTIPOSMANT         = "GESTION TIPOS MANT",
    GESTIONACTIVIDADESMANT   = "GESTION ACTIVIDADES MANT"
}
